module.exports = __webpack_public_path__ + "static/024-7c29d84136e0747128d6837db1272132.jpg";